import adminApi from "./adminApi";


export async function getUsers() {

  const response = await adminApi.get(
    "/admin/users"
  );

  return response.data.users || [];
}